// src/pages/LocationChooser.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const LocationChooserPage = () => {
  const navigate = useNavigate();

  const handleLocationSelection = (locationId) => {
    navigate(`/location/${locationId}`);
  };

  return (
    <div className="location-chooser">
      <h1>Escolha o local</h1>
      <div>
        <button onClick={() => handleLocationSelection(1)}>Rua Travessa 7</button>
      </div>
      {process.env.NODE_ENV === 'development' && (
        <div className="mt-4">
          <button 
            className="btn btn-outline-secondary"
            onClick={() => navigate('/registo')}
          >
            Formulário de Registo
          </button>
        </div>
      )}
    </div>
  );
};

export default LocationChooserPage;
